import * as types from '../actions/actionTypes'
import initialState from './initialState'

export default function setReferralSiteReducer(
    state = initialState.referringSite,
    action
) {
    switch (action.type) {
        case types.SET_REFERRAL_SITE:
            return action.referringSite
        default:
            return state
    }
}